import type {CabinetNotification, CabinetNotificationsApi, NotificationGroupKey} from "../api/cabinetNotifications";
import {
  createMerchantTelegramLink,
  disconnectMerchantTelegramChat,
  getMerchantNotificationSettings,
  listMerchantNotifications,
  markMerchantNotificationsSeen,
  NOTIFICATION_GROUP_KEYS,
  revokeMerchantTelegramLink,
  saveMerchantNotificationSettings,
  testMerchantTelegram,
} from "../api/merchantNotifications";
import {TRADER_NOTIFICATION_GROUP_KEYS, traderNotificationsApi} from "../api/traderNotifications";

/** Чем кабинеты отличаются в разделе «Уведомления»; лента, колокольчик и настройки у них общие. */
export interface NotificationScope {
  api: CabinetNotificationsApi;
  groupKeys: readonly NotificationGroupKey[];
  feedRoute: string;
  settingsRoute: string;
  /** Ссылка под уведомлением внутри кабинета. */
  itemHref: (item: CabinetNotification) => string | null;
}

export const MERCHANT_NOTIFICATIONS: NotificationScope = {
  api: {
    list: listMerchantNotifications,
    markSeen: markMerchantNotificationsSeen,
    getSettings: getMerchantNotificationSettings,
    saveSettings: saveMerchantNotificationSettings,
    createLink: createMerchantTelegramLink,
    revokeLink: revokeMerchantTelegramLink,
    testTelegram: testMerchantTelegram,
    disconnectChat: disconnectMerchantTelegramChat,
  },
  groupKeys: NOTIFICATION_GROUP_KEYS,
  feedRoute: "#/merchant/notifications",
  settingsRoute: "#/merchant/settings/notifications",
  itemHref: (item) => (item.orderId ? `#/merchant/orders/${encodeURIComponent(item.orderId)}` : null),
};

export const TRADER_NOTIFICATIONS: NotificationScope = {
  api: traderNotificationsApi,
  groupKeys: TRADER_NOTIFICATION_GROUP_KEYS,
  feedRoute: "#/notifications",
  settingsRoute: "#/settings/notifications",
  // Своей страницы заявки у трейдера нет: адрес приходит с сервера.
  itemHref: (item) => (item.href?.startsWith("#/") ? item.href : null),
};
